import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import global from './modules/global'
import myTasks from './modules/myTasks'
import myTaskItem from './modules/myTaskItem'
import management from './modules/management'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  actions,
  getters,
  modules: {
    global,
    myTasks,
    myTaskItem,
    management
  },
  strict: debug
})

export default store
